
export const VAPIDKEY = "BKMp_AEsN3nj-kzAMzVo-pP5n1RtUtIT3AMbqQgbzdAZUqKZz07wc_l7ZIFttbXqxrr27ba7Ru90jmqLpCaXcoY"
